import React, { useState } from 'react';
import axios from 'axios';
import config from '../../../settings/config.json';
import { Button, Form, Input, Space, Upload } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { Alert } from 'antd';

const { Dragger } = Upload;
const layout = {
  labelCol: {
    span: 4,
  },
  wrapperCol: {
    span: 16,
  },
};
const tailLayout = {
  wrapperCol: {
    offset: 8,
    span: 16,
  },
};
const tailLayoutM = {
  wrapperCol: {
    offset: 6,
    span: 16,
  },
};

function AddPoem() {  
  const [form] = Form.useForm();
  const [image, setImage] = useState([]);
  const [showAlert, setShowAlert] = useState(false);

  const onReset = () => {
    form.resetFields();
  };

  const handleClose = () => {
    setShowAlert(false)
  }

  const handleSubmit = async (values) => {
    const formData = new FormData();
    formData.append('name', values.name);
    formData.append('content', values.content);
    formData.append('speaker', values.speaker);

    if (values.upload && values.upload.fileList.length > 0) {
      formData.append('file', values.upload.fileList[0].originFileObj);
    }

    if (values.audioUpload && values.audioUpload.fileList.length > 0) {
      values.audioUpload.fileList.forEach(file => {
        formData.append('audioFiles', file.originFileObj);
      });
    }

    try {
      const response = await axios.post(`/api/addPoetry`, formData, {
        headers: { 
          'Content-Type': 'multipart/form-data'
        }
      });

      setImage([...image, { name: response.data.name, url: response.data.url }]);
      setShowAlert(true)

      onReset();
    } catch (error) {
      console.error('Ошибка при отправке стиха:', error);
    }
  };
  
  return (
    <div className='form-container'>
        <>
          <Form
            {...layout}
            form={form}
            name="control-hooks"
            onFinish={handleSubmit}
            style={{ maxWidth: 600 }}
            className="centered-form"
          >
            {showAlert && (
              <center>
                <Alert message="Əlavə edildi" type="success" showIcon closable afterClose={handleClose} style={{ maxWidth: 370 }} />;
              </center>
            )}
            <Form.Item
              name="name"
              label="Ad"
              rules={[{ required: true, message: '' }]}
            >
              <Input size="large" />
            </Form.Item>
            <Form.Item
              name="content"
              label="Şeir"
              rules={[{ required: true, message: '' }]}
            >
              <Input.TextArea rows={6} size="large" />
            </Form.Item>
            <Form.Item
              name="upload"
              label="Şəkil"
              rules={[{ required: true, message: 'Şəkili yükləməyi unutdunuz!' }]}
            >
              <Dragger
                name="upload"
                beforeUpload={() => false}
                maxCount={1}
                listType="picture"
                onChange={({ fileList }) => {
                  form.setFieldsValue({ upload: { fileList } });
                }}
              >
                <Button icon={<UploadOutlined />}>Upload</Button>
              </Dragger>
            </Form.Item>
            <Form.Item
              name="audioUpload"
              label="Audio"
              rules={[{ required: false }]}
            >
              <Dragger
                name="audioUpload"
                beforeUpload={() => false}
                multiple
                listType="text"
                onChange={({ fileList }) => {
                  form.setFieldsValue({ audioUpload: { fileList } });
                }}
              >
                <Button icon={<UploadOutlined />}>Upload</Button>
              </Dragger>
            </Form.Item>
            <Form.Item
              name="speaker"
              label="Səs"
              rules={[{ required: false, message: '' }]}
            >
              <Input size="large" />
            </Form.Item>
            <Form.Item {...tailLayoutM}>
              <Space>
                <Button type="primary" size="large" danger htmlType="submit">
                  Göndər
                </Button>
                <Button type="dashed" secondary size="large" htmlType="button" onClick={onReset}>
                  Sil
                </Button>
              </Space>
            </Form.Item>
          </Form>
      </>
    </div>
  );
}

export default AddPoem;